import { Component, Input } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
})
export class EmptyStateComponent {
  @Input() title = 'Sem resultados';
  @Input() message = 'Nenhum registro para exibir';

  // Animação real do portal (assets/animations/request-empty.json, baixada
  // de portal-hml.affixtech.com.br em 21/08/2026) — 280x280px, mesmo tamanho
  // observado no original.
  animationOptions: AnimationOptions = {
    path: 'assets/animations/request-empty.json',
    loop: true,
    autoplay: true,
  };
}
